import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import type { ReactNode } from 'react';

export default function HomepageSection({ children }: { children: ReactNode }) {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });
  return <div ref={ref} className={isVisible ? 'homepage-section-enter' : undefined}>{children}</div>;
}